import { useState } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useTran } from "@/hooks";
import { User, Settings, LogOut, ChevronDown } from "lucide-react";
import { useAuthStore } from "@/features/auth/hooks";
import { PATHS } from "@/lib/router";
import { showToast } from "@/lib/utils/toast";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const UserMenu = observer(() => {
  const navigate = useNavigate();
  const { t } = useTran();
  const { user, logout } = useAuthStore();
  const [open, setOpen] = useState(false);

  // Hide if not authenticated
  if (!user) return null;

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    showToast.success("Logged out successfully");
    navigate(PATHS.LOGIN);
  };

  const handleProfile = () => {
    setOpen(false);
    navigate(PATHS.PROFILE);
  };

  const handleSettings = () => {
    setOpen(false);
    navigate(PATHS.SETTINGS);
  };

  const displayName = user.name || user.username || user.email;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1 rounded-radius py-1 pl-1 pr-2 hover:bg-muted transition-colors">
          <div className="relative flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
            <User className="h-4 w-4 text-primary" />
          </div>
          <span className="text-sm font-medium hidden sm:inline">
            {displayName}
          </span>
          <ChevronDown className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {/* <DropdownMenuItem onClick={handleProfile} className="cursor-pointer"> */}
        {/*   <User className="mr-2 h-4 w-4" /> */}
        {/*   <span>{t("Profile")}</span> */}
        {/* </DropdownMenuItem> */}
        <DropdownMenuItem onClick={handleSettings} className="cursor-pointer">
          <Settings className="mr-2 h-4 w-4" />
          <span>{t("Settings")}</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleLogout}
          className="cursor-pointer text-red-600"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>{t("Logout")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});

export default UserMenu;
